export default "__VITE_ASSET__CKek9u$2__"